export default __webpack_public_path__ + "static/media/pdc_mobility_step4.ad1e559d.svg";